// removed by extract-text-webpack-plugin
module.exports = {"container":"container___WLHt9","requestContainer":"requestContainer___1i0TU","requestTitle":"requestTitle___2tukh","requestSubTitle":"requestSubTitle___1nbAu","catHeader":"catHeader___2Yiod","catContainer":"catContainer___JOYXu","requestsHeader":"requestsHeader___3-BiE","statics":"statics___2aLSd","filter":"filter___3B_HY","select":"select___1UvB0"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ReviewRequests/ReviewRequests.module.css
// module id = 375
// module chunks = 0